"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var lodash_1 = require("lodash");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var AmenityItem = function (_a) {
    var icon = _a.icon, data = _a.data, title = _a.title, _b = _a.makeTranslation, makeTranslation = _b === void 0 ? true : _b;
    var _c = react_1.useState(false), expanded = _c[0], setExpanded = _c[1];
    var translationNameSpace = 'FIELD_OPTIONS';
    var t = react_i18next_1.useTranslation('common').t;
    var getTranslated = function (title) {
        return t(translationNameSpace + '.' + title, title);
    };
    var toggleExpand = function () {
        setExpanded(!expanded);
    };
    var getExpandedData = function () {
        if (data.length < 2) {
            return getTranslated(data[1]);
        }
        if (lodash_1.isArray(data)) {
            return data
                .slice(1)
                .map(function (a) { return getTranslated(a); })
                .join(', ');
        }
    };
    return !lodash_1.isUndefined(data) ? (react_1.default.createElement("div", { className: classnames_1.default('amenity-item', {
            expanded: expanded,
        }) },
        react_1.default.createElement("div", { className: "push-left" },
            icon && react_1.default.createElement("i", { className: icon }),
            react_1.default.createElement("span", { className: "title" }, title)),
        react_1.default.createElement("div", { className: "amenity-info " + (lodash_1.isArray(data) && data.length > 1 ? 'expandable' : ''), onClick: toggleExpand },
            lodash_1.isString(data) && makeTranslation && getTranslated(data),
            lodash_1.isString(data) && !makeTranslation && data,
            react_1.default.createElement("p", null,
                expanded && lodash_1.isArray(data) && getTranslated(data[0]),
                expanded && (data === null || data === void 0 ? void 0 : data.length) > 1 && lodash_1.isArray(data) && (react_1.default.createElement("span", { className: "counter" }, " \u2212 "))),
            react_1.default.createElement("p", null,
                !expanded && lodash_1.isArray(data) && data.length
                    ? getTranslated(data[0])
                    : '',
                !expanded && lodash_1.isArray(data) && (data === null || data === void 0 ? void 0 : data.length) > 1 && (react_1.default.createElement("span", { className: "counter" },
                    "\u00A0+",
                    data.length - 1))),
            expanded && lodash_1.isArray(data) && data.length > 1 && (react_1.default.createElement("p", { className: styles_module_scss_1.default.option_list }, getExpandedData()))))) : (react_1.default.createElement(react_1.default.Fragment, null));
};
exports.default = AmenityItem;
